// extracted by mini-css-extract-plugin
export var fullGrid = "_3p-3";
export var pdpPreviewContainer = "_3p-1";
export var previewContainer = "_3p-0";
export var togglePreviewContainer = "_3p-2";